module.exports = __webpack_public_path__ + "img/zgxd.0af24ee4.png";